import { isFunction } from 'lodash-es';
import { unstable_LowPriority, unstable_scheduleCallback } from 'scheduler';

/**
 * A Deferred callback using react's internal scheduler
 * @param func function to be called
 * @param priority a scheduler priority, one of
 *          `unstable_LowPriority`,
 *          `unstable_ImmediatePriority`,
 *          `unstable_UserBlockingPriority`,
 *          `unstable_NormalPriority`,
 *          `unstable_IdlePriority`,
 *          `unstable_LowPriority`
 */
export const deferredRenderCall = (func: () => void, priority: any = unstable_LowPriority) => {
  unstable_scheduleCallback(priority, () => {
    func();
  });
};

export const runIfFun = <T, U>(valueOrFn: ((...fnArgs: U[]) => T) | T, ...args: U[]): T =>
  isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;

export type MaybeRenderProp<P> = ((props: P) => React.ReactNode) | React.ReactNode;
